export const ssoEnvUrl = {
    prod: 'tt.sankuai.com',
    staging: 'tt.fetc.st.sankuai.com',
    test: 'tt.cloud.test.sankuai.com'
};
